<template>
  <div id="list-wrap">
    <div class="container">
      <div class="header" ref="header">
        <div>
          <div><img src="../assets/image/Vcar_List/logo.png"></div>
          <p>{{userName}}</p>
        </div>
        <button @click="toVcarCollectPage">发起寻车</button>
      </div>
      <div class="main" ref="main">
        <div class="main-top vc_data_number">
          <div>
            <p>{{notAlready}}</p>
            <p>等待寻车</p>
          </div>
          <div>
            <p>{{already}}</p>
            <p>已经寻车</p>
          </div>
          <div>
            <p>{{all}}</p>
            <p>所有寻车</p>
          </div>
        </div>
        <div class="main-center search_data">
          <div class="sign">
            <sup class="sign-num" v-if="read!=null&&read!=''&&read!=0">{{read}}</sup>
            <img src="../assets/image/Vcar_List/sign.png"></img>
          </div>
          <div class="search">
            <input type="text" placeholder="车型/城市" v-model="search">
          </div>
          <div class="sort" @click="orderByTime">
            <p>时间</p>
            <img src="../assets/image/Vcar_List/sort.png">
          </div>
        </div>
      </div>
      <div class="footer" ref="foot" :style="{height:footH}">
        <div class="footer-content vc-data-list"  v-infinite-scroll="loadMore" infinite-scroll-disabled="loading" infinite-scroll-distance="10">

          <div class="item" v-for="(vcInfoObj, index) in vcListData" @click="toVcarResultPage(vcInfoObj.id)">
            <div class="vc-status">
              <div>
                <div>
                  <p>{{vcInfoObj.rstTimeC == null?'等待寻车':'已经寻车'}}</p>
                  <div class="unread" v-if="vcInfoObj.rstTimeC!= null&&vcInfoObj.reqReadtimeC==null"></div>
                </div>
                <p class="vc_time">{{vcInfoObj.rstTimeC}}</p>
              </div>
            </div>
            <div class="vc-sign" :class="vcInfoObj.rstTimeC != null?'found-car-sign':''"></div>
            <div class="car-info-1">
              <p>{{vcInfoObj.reqBrandC}} {{vcInfoObj.reqVehSeriesC}} {{vcInfoObj.reqVehTypeC}} {{vcInfoObj.reqVehMsrpC != null? '指导价 '+ vcInfoObj.reqVehMsrpC:''}}</p>
            </div>
            <div class="car-info-2">
              <p>{{vcInfoObj.reqVehXcolorC}}/{{vcInfoObj.reqVehCityC}}/{{vcInfoObj.reqVehNoteC}}</p>
              <p>{{vcInfoObj.reqTimeC}}</p>
            </div>
          </div>
          <div class="loadmore" v-show="loading">
            <p>------------ {{loadText}} -------------</p>
          </div>

        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import qs from 'qs'
  import commons from '../utils/common'
  import constants from '../utils/constants'

  export default {
    name: "Vcar_List",
    data() {
      return {
        footH: 0, // list滚动框高度
        userName: null,
        all: 0, // 所有寻车
        read: 0, // 未读寻车
        already: 0, // 已经寻车
        notAlready: 0,  // 等待寻车
        currentPage: 1, // 当前页
        pageSize: 10, // 每页条数
        orderBy: 'DESC', // 排序字段
        search: null,
        vcLoadData: [],
        vcListData: [],
        loading: null,
        loadText: '加载更多',
        ajaxFlag: false,
        loadEvent: false,
        timeout: null
      }
    },
    watch: {
      search(curVal, oldVal) {
        // 实现input连续输入，只发一次请求
        clearTimeout(this.timeout)
        this.timeout = setTimeout(() => {
          if(commons.trimAll(curVal) != commons.trimAll(oldVal)){
            this.handleChangeSearch(curVal)
          }
        }, 500)
      }
    },
    mounted() {
      if(commons.isEmpty(sessionStorage.getItem("mobile"))){
        commons.redirect(this, 'var_login')
      }
      this.$nextTick(function () {
        const that = this
        // 延时，以获取准确的高度
        setTimeout(() => {
          this.setFootH()
        }, 200);
        // 设值用户显示
        that.userName = sessionStorage.getItem("customerName")
        // 获取寻车数目
        let data = {"mobile": sessionStorage.getItem("mobile")}
        that.$axios.post('/marketing/vhvm/count', qs.stringify(data)).then(function (res) {
          if(res.data.code == 0) {
            that.all = res.data.data.all
            that.read = res.data.data.read
            that.already = res.data.data.already
            that.notAlready = res.data.data.notAlready
          }
        }).catch(function (error) {
          commons.tipToast(error.data.msg)
          return
        });
        that.getVcarData(that.currentPage, that.orderBy)

        commons.wxShare(that, constants.VC_SHAREINFO)
      })
    },
    methods: {
      handleChangeSearch (value) {
        this.$refs.foot.scrollTop  = 0
        this.search = commons.trimAll(value)
        this.vcLoadData = []
        this.vcListData = []
        this.currentPage = 1
        this.orderBy = 'DESC'
        this.getVcarData(this.currentPage, this.orderBy)
      },

      getVcarData(currentPage, orderBy) {
        const that = this
        // 获取列表信息
        let data = {
          "mobile": sessionStorage.getItem("mobile"),
          "orderBy": orderBy,
          "search": that.search
        }
        that.$axios.post('/marketing/vhvm/list?size='+that.pageSize+'&current='+that.currentPage, qs.stringify(data)).then(function (res) {
          that.vcLoadData = res.data.data.records
          for(let key in that.vcLoadData) {
            that.vcListData.push(that.vcLoadData[key])
          }
          that.loadEvent = true
        }).catch(function (error) {
          commons.tipToast(error.data.msg)
          return
        });
      },

      /* 滚动框高度计算 */
      setFootH() {
        this.footH = (document.documentElement.clientHeight - this.$refs.header.offsetHeight - this.$refs.main.offsetHeight) + 'px'
      },
      /*点击‘发起寻车’，转到寻车信息收集页面*/
      toVcarCollectPage() {
        if(commons.isEmpty(sessionStorage.getItem("userInfoFlag"))){
          commons.redirect(this, 'vcar_personalInformation')
          return
        }
        commons.redirect(this, 'vcar_collect')
      },
      /*点击列表中的Cell,跳转到对应的寻车结果页*/
      toVcarResultPage(id) {
        if(commons.isEmpty(sessionStorage.getItem("userInfoFlag"))){
          commons.redirect(this, 'vcar_personalInformation')
          return
        }
        sessionStorage.setItem("id", id)
        commons.redirect(this, 'vcar_result')
      },

      orderByTime(){
        if(commons.isEmpty(sessionStorage.getItem("userInfoFlag"))){
          commons.redirect(this, 'vcar_personalInformation')
          return
        }
        this.$refs.foot.scrollTop  = 0
        this.currentPage = 1
        if(this.orderBy == 'ASC') {
          this.orderBy = 'DESC'
        }else{
          this.orderBy = 'ASC'
        }
        this.vcLoadData = []
        this.vcListData = []
        this.getVcarData(this.currentPage, this.orderBy)
      },

     loadMore() {
       const that = this
       if(that.loadEvent){
         if(!that.ajaxFlag){
           if(that.vcLoadData != null && that.vcLoadData.length == 10) {
             that.currentPage = that.currentPage + 1
             // 获取列表信息
             let data = {
               "page": {size: that.pageSize, current: that.currentPage},
               "mobile": sessionStorage.getItem("mobile"),
               "orderBy":that.orderBy,
               "search": that.search
             }
             that.loading = true;
             that.ajaxFlag = true
             that.$axios.post("marketing/vhvm/list?size=" + that.pageSize + '&current=' + that.currentPage, qs.stringify(data)).then(function (res) {
               that.vcLoadData = res.data.data.records
               if (that.vcLoadData != null && that.vcLoadData.length > 0) {
                 for (let key in that.vcLoadData) {
                   that.vcListData.push(that.vcLoadData[key])
                 }
               }
               that.loading = false
               that.ajaxFlag = false
             }).catch(function (error) {
               that.ajaxFlag = false
               commons.tipToast(error.data.msg)
               return
             })
           }
         }
       }
      }
    }
  }
</script>

<style scoped>
  p,div,sup {
    font-family: "PingFang SC";
  }

  #list-wrap {
    width: 100vw;
    background-color: #fff;
  }

  .container {
    margin: 0 auto;
    width: 7.5rem;
    /*overflow: hidden;*/
  }

  #login-wrap > .container {
    margin: 0 auto;
    width: 7.5rem;
  }

  .container > .header {
    margin: 0 auto;
    padding-top: 0.39rem;
    width: 6.86rem;
    display: flex;
    flex-flow: row nowrap;
    justify-content: space-between;
    align-items: center;
  }

  .container > .header > div {
    display: flex;
    flex-flow: row nowrap;
    align-items: center;
  }

  .container > .header > div > div {
    width: 1.2rem;
    height: 1.2rem;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 0.44rem;
    color: #FFFFFF;
    letter-spacing: -0px;
    /*opacity: 0.13;*/
    border-radius: 50%;
    /*background-image: linear-gradient(90deg, #195EDB 0%, #2594FE 100%);*/
  }
  .container > .header > div > div > img {
    width: 100%;
    height: 100%;
  }

  .container > .header > div > p {
    margin: 0;
    margin-left: 0.31rem;
    font-size: 0.36rem;
    color: #000000;
    letter-spacing: -0px;
  }

  .container > .header > button {
    width: 1.96rem;
    height: 0.65rem;
    background-image: linear-gradient(90deg, #195EDB 0%, #2594FE 100%);
    border-radius: 3.25rem;
    border-width: 0;
    outline: none;
    font-size: 0.28rem;
    color: #FFFFFF;
    letter-spacing: -0px;
    text-align: center;
  }

  .container > .main {
    margin: 0 auto;
    padding-top: 0.28rem;
    padding-bottom: 0.29rem;
    width: 6.86rem;
  }

  .container > .main > .main-top {
    margin: 0 auto;
    width: 6.02rem;
    display: flex;
    flex-flow: row nowrap;
    align-items: center;
    justify-content: space-between;
  }


  .container > .main > .main-top > div {
    text-align: center;
  }

  .container > .main > .main-top > div > p {
    margin: 0;
    font-size: 0.32rem;
    color: #000000;
    letter-spacing: -0px;
    line-height: 0.45rem;
  }

  .container > .main > .main-top > div > p:last-child {
    font-size: 0.24rem;
    color: #000000;
    letter-spacing: -0px;
    line-height: 0.33rem;
  }

  .container > .main > .main-center {
    margin-top: 0.5rem;
    margin-left: 0.42rem;
    width: 6.24rem;
    height: 0.6rem;
    display: flex;
    flex-flow: row nowrap;
    align-items: center;
    justify-content: space-between;
  }

  .container > .main > .main-center > .sign {
    position: relative;
    width: 0.33rem;
    height: 0.32rem;
    font-size: 0;
  }

  .container > .main > .main-center > .sign > .sign-num {
    position: absolute;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 0.28rem;
    height: 0.28rem;
    top: -0.16rem;
    left: 0.165rem;
    font-size: 0.22rem;
    color: #FFFFFF;
    letter-spacing: -0px;
    text-align: center;
    background: #FF4A26;
    border-radius: 50%;
  }

  .container > .main > .main-center > .sign > img {
    width: 100%;
  }

  .container > .main > .main-center > .sort {
    display: flex;
    flex-flow: row nowrap;
    align-items: center;
    font-size: 0;
  }

  .container > .main > .main-center > .search {
    margin: 0;
    padding: 0;
  }

  .container > .main > .main-center > .search > input {
    border-width: 0;
    border-radius: 0.3rem;
    width: 4.08rem;
    height: 0.6rem;
    display: block;
    outline: 0;
    background: #F5F5F7;
    font-size: 0.28rem;
    color: #8D8E99;
    letter-spacing: -0px;
    text-align: center;
  }

  .container > .main > .main-center > .sort > p {
    margin: 0;
    font-size: 0.28rem;
    color: #000000;
    letter-spacing: -0px;
    text-align: right;
  }

  .container > .main > .main-center > .sort > img {
    margin-left: 0.07rem;
    width: 0.3rem;
    height: 0.3rem;
  }

  .container > .footer {
    /*border: 1px solid black;*/
    margin-top: 0!important;
    width: 100%;
    background: rgba(216, 216, 216, 0.19);
    overflow: auto;
  }

  .container > .footer > .footer-content {
    /*border: 1px solid black;*/
    margin: 0 auto;
    padding-bottom: 0.30rem;
    width: 6.68rem;
    /*overflow: auto;*/
  }

  .footer-content::-webkit-scrollbar {
    display: none
  }

  .container > .footer > .footer-content > .item {
    margin-top: 0.32rem;
    width: 100%;
    background: #fff;
  }

  .container > .footer > .footer-content > .item > .vc-status {
    width: 100%;
    background: rgba(216, 216, 216, 0.19);
  }

  .container > .footer > .footer-content > .item > .vc-status > div {
    margin: 0 auto;
    width: 6.22rem;
    height: 0.42rem;
    display: flex;
    flex-flow: row nowrap;
    align-items: center;
    justify-content: space-between;
  }

  .container > .footer > .footer-content > .item > .vc-status > div > div {
    display: flex;
    flex-flow: row nowrap;
    align-items: center;
  }

  .container > .footer > .footer-content > .item > .vc-status > div > div > p {
    margin: 0;
    font-size: 0.30rem;
    font-weight: bold;
    color: #000000;
    letter-spacing: -0px;
    text-align: left;
  }

  .container > .footer > .footer-content > .item > .vc-status > div > div > .unread {
    margin-left: 0.14rem;
    width: 0.13rem;
    height: 0.13rem;
    background: #FF4A26;
    border-radius: 50%;
  }

  .container > .footer > .footer-content > .item > .vc-status > div > .vc_time {
    margin: 0;
    font-size: 0.24rem;
    color: #000000;
    letter-spacing: -0px;
  }

  .container > .footer > .footer-content > .item > .vc-sign {
    width: 100%;
    height: 0.1rem;
    background-image: linear-gradient(90deg, #195EDB 0%, #2594FE 100%);
  }

  .found-car-sign {
    background-image: linear-gradient(90deg, #FA856E 0%, #195EDB 100%) !important;
  }

  .container > .footer > .footer-content > .item > .car-info-1,
  .container > .footer > .footer-content > .item > .car-info-2 {
    margin: 0 auto;
    margin-top: 0.18rem;
    width: 6.22rem;
    display: flex;
    flex-flow: row nowrap;
  }

  .container > .footer > .footer-content > .item > .car-info-2 {
    margin-top: 0.11rem;
    padding-bottom: 0.18rem;
    justify-content: space-between;
  }

  .container > .footer > .footer-content > .item > .car-info-1 > p {
    margin: 0;
    font-size: 0.26rem;
    color: #000000;
    letter-spacing: -0px;
  }

  .container > .footer > .footer-content > .item > .car-info-1 > p {
    margin: 0;
    width: 100%;
    font-size: 0.26rem;
    font-weight: bold;
    line-height: 0.37rem;
    color: #000000;
    letter-spacing: -0px;
    white-space: nowrap; /*设置不换行*/
    overflow: hidden; /*设置隐藏*/
    text-overflow: ellipsis; /*设置隐藏部分为省略号*/
    text-align: left;
  }

  .container > .footer > .footer-content > .item > .car-info-2 > p:first-child {
    max-width: 3rem;
    white-space: nowrap; /*设置不换行*/
    overflow: hidden; /*设置隐藏*/
    text-overflow: ellipsis; /*设置隐藏部分为省略号*/
    text-align: left;
  }

  .container > .footer > .footer-content > .item > .car-info-2 > p {
    margin: 0;
    font-size: 0.24rem;
    line-height: 0.37rem;
    color: #979797;
    letter-spacing: -0px;
    text-align: right;
  }

  .loadmore {
    margin-top: 0.30rem!important;
    width: 100%;
    display: flex;
    justify-content: center;
    font-size: 0.26rem;
    color: #a8a5a5;
    /*background: rgba(216, 216, 216, 0.19);*/
  }

</style>



// WEBPACK FOOTER //
// src/components/Vcar_List.vue